import parse, { domToReact } from "html-react-parser";
import Icon from "./icon";
import Translate from "./translate";
import { downloadDocument } from "../utils/documents";

const RadioCheckboxAnswers = ({ type, name, required, answer, attachments }) => {
  const opt = {
    replace: (elem) => {
      if (elem.type === "tag" && elem.name === "button") {
        const document = attachments?.find(
          (att) =>
            att.fileName.split(".")[0] === elem.attributes.find((attr) => attr.name === "id")?.value
        );
        const download = async () => await downloadDocument(document, true);
        return document ? (
          <button onClick={download} type="button" className="form__label-button link link--accent">
            {domToReact(elem.children)} <Icon name="download" />
          </button>
        ) : (
          <span>{domToReact(elem.children)}</span>
        );
      }
    },
  };

  const parsedContent = answer.label ? parse(answer.label, opt) : "";

  const answerLabel =
    typeof parsedContent === "string" ? (
      <Translate text={parsedContent} />
    ) : (
      parsedContent?.map((elem, j) => {
        //TODO: handle parsed elem on-demand translation
        return j === 0 ? <Translate text={elem} key={j} /> : elem;
      })
    );

  return (
    <label htmlFor={`${name}-${answer.id}`} className={`form__${type}-label`}>
      {required && type === "checkbox" && <span className="form__required-symbol">*</span>}
      {answerLabel}
    </label>
  );
};

export default RadioCheckboxAnswers;
